module.exports = __webpack_public_path__ + "static/media/pantone_rank.9ee964ee.svg";